import { Group, Text } from '@mantine/core';

export type StatRowProps = {
  label: string;
  value: string | number;
};

export function StatRow({ label, value }: StatRowProps) {
  return (
    <Group justify="space-between">
      <Text size="sm" c="dimmed">
        {label}
      </Text>
      <Text size="sm">{value}</Text>
    </Group>
  );
}
